import React from "react";
const partners = [{
  name: "IBM",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/IBM-1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/IBM-1.png",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/IBM-1.png"
}, {
  name: "Fortinet",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/Fortinet-2.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/Fortinet-2.png",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/Fortinet-2.png"
}, {
  name: "Cisco",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/Cisco-1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/Cisco-1.png",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/Cisco-1.png"
}, {
  name: "Splunk",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/Splunk-1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/Splunk-1.png",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/Splunk-1.png"
}, {
  name: "ExtraHop",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/ExtraHop-1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/ExtraHop-1.png",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/ExtraHop-1.png"
}, {
  name: "Dell Technologies",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/Dell-1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/Dell-1.png",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/Dell-1.png"
}, {
  name: "NxtHop",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/NxtHop-1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/NxtHop-1.png",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/NxtHop-1.png"
}, {
  name: "AWS",
  logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/AWS-1.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/AWS-1.png",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1683494/img/AWS-1.png"
}, {
  name: "Ammune.ai",
  logo: "https://fetc.ae/wp-content/uploads/2026/05/Ammune.avif?v=gkxtnlurfpc",
  srcset: "https://fetc.ae/wp-content/uploads/2026/05/Ammune.avif?v=gkxtnlurfpc",
  sizes: "https://fetc.ae/wp-content/uploads/2026/05/Ammune.avif?v=gkxtnlurfpc"
}];
export default function TechnologyPartners() {
  return <section data-section-id="261214" id="technology-partners" className="bg-[#F2F5F8] text-foreground pt-20 pb-14 px-6 md:px-12 lg:px-24 overflow-hidden light animate-in fade-in duration-700">
      <div className="max-w-7xl mx-auto flex flex-col items-center">
        <h2 className="font-mono text-sm font-semibold uppercase tracking-widest text-[#0B1220] mb-4 text-center">
          TECHNOLOGY PARTNERS
        </h2>
        <div className="w-12 h-1 bg-[#13B8C8] mb-13 md:mb-20" />
<div className="grid grid-cols-3 gap-9 md:gap-20 w-full place-items-center">
  {partners.map((partner, i) => <div key={i} data-index={i} className="flex h-12 md:h-16 items-center justify-center">
      <img src={partner.logo} data-wvc-srcset={partner.srcset} data-wvc-sizes={partner.sizes} alt={`${partner.name} logo`} className="block object-contain max-h-10 md:max-h-12 w-auto max-w-[95px] md:max-w-[130px]" loading="lazy" decoding="async" />
    </div>)}
</div>
      </div>
    </section>;
}